import { PAGE_LEVEL_ERROR, UPDATE_USER, UPDATE_ALERT, UPDATE_BASE_CURRENCY, UPDATE_SELECTED_MARKET_ID } from "./types";
import initialState from "./state";

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case PAGE_LEVEL_ERROR:
      return { ...state, error: action.payload ? { ...action.payload } : null };
    case UPDATE_USER:
      return { ...state, authUser: action.payload };
    case UPDATE_ALERT:
      return { ...state, alert: action.payload };
    case UPDATE_BASE_CURRENCY:
      return { ...state, baseCurrency: action.payload }
    case UPDATE_SELECTED_MARKET_ID:
      return { ...state, selectedMarketId: action.payload }
    default:
      return state;
  }
};
